import React from 'react';
import Heading from 'components/atoms/text/heading';
import Subtitle from 'components/atoms/text/subtitle';
import PrimaryButton from 'components/atoms/buttons/primary';
import useResponsiveness from '_helpers/hooks/useResponsiveness';
import { IMAGE, NAME, TITLE, CV } from './constants/ConstHome';
import './home.scss';

export default function Home() {
  const { isMobile } = useResponsiveness();
  return (
    <>
      <img className="blob cursor-pointer mx-auto w-28 sm:w-48 rounded-full" alt="Sherif Mohammad" src={IMAGE} />
      <Heading text={NAME} styles="mt-1 sm:mt-4" />
      <Subtitle text={TITLE} />
      <PrimaryButton text={CV.title} styles="mx-auto mt-3 sm:mt-4" onClick={() => window.open(CV.link, '_blank')} />
      {isMobile() && (
        <div className="mt-2">Pro tip: Navigate between pages by performing a long swipe up or down! 🚀</div>
      )}
    </>
  );
}
